import { useEffect, useState } from "react";

const useParts = () => {
  const [parts, setParts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetch("https://mbababd24.onrender.com/part")
      .then((res) => res.json())
      .then((data) => {
        setParts(data);
        setIsLoading(false);
      });
  }, []);

  return [parts, isLoading];
  // return { ! isLoading ? ( [parts, isLoading]) : ( [isLoading])}
};

export default useParts;
